export const DistrictPage = {
	PAGINATION_COUNT: 15,
};
